/* eslint-disable no-undef */

import { Amplify } from 'aws-amplify';

if (process.env.REACT_APP_ENV === 'prod') {
  Amplify.configure({
    Auth: {
      region: 'eu-central-1',
      userPoolId: 'eu-central-1_rQYSbsp4O',
      userPoolWebClientId: '5c5g6i3ug137id39u2fd3vb1sv',
      // Required for the Cognito user migration trigger from the old pool
      authenticationFlowType: 'USER_PASSWORD_AUTH',
    },
  });
} else if (process.env.REACT_APP_ENV === 'dev') {
  Amplify.configure({
    Auth: {
      identityPoolId: 'eu-central-1:1dcb2a83-47fa-4bba-ac35-f8255e7a7ea8',
      region: 'eu-central-1',
      userPoolId: 'eu-central-1_5KZp51rup',
      userPoolWebClientId: '6olr7a6fvku9vb85vtcolvgrh9',
    },
  });
} else if (process.env.REACT_APP_ENV === 'local') {
  Amplify.configure({
    Auth: {
      identityPoolId: 'eu-central-1:1dcb2a83-47fa-4bba-ac35-f8255e7a7ea8',
      region: 'eu-central-1',
      userPoolId: 'eu-central-1_5KZp51rup',
      userPoolWebClientId: '6olr7a6fvku9vb85vtcolvgrh9',
    },
  });
}

console.log('ENV: ', process.env.REACT_APP_ENV);
